import { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'

import { Layout, Typography, Tabs, Image, Skeleton } from 'antd'
import { Icon } from '@iconify/react'

// store
import { applyForJobDetail, jobState } from '../store/job.slice'

// assets
import Logo from '../../../assets/images/logo_dark.png'

import './index.css'
import styles from './applyForJob.module.css'
import ApplicationForm from './applicationForm'

const { Title, Text } = Typography

const ApplyForJobPublicPage = () => {
    const dispatch = useDispatch()

    const { id } = useParams()

    const { jobDetailsApply, jobLoading } = useSelector(jobState)

    const [activeKey, setActiveKey] = useState('overview')

    useEffect(() => {
        dispatch(applyForJobDetail(id))
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <Layout className={`${styles.page} public-job-apply-page`}>
            <div className={styles.hero}>
                <div className={styles.logo}>
                    <Image src={Logo} alt="Logo" preview={false} height={52} />
                </div>
                {jobLoading ? (
                    <Skeleton
                        className={styles.heroSkeleton}
                        active
                        paragraph={{ rows: 2 }}
                        title={false}
                    />
                ) : (
                    <>
                        <Title
                            level={3}
                            className={styles.jobTitle}
                            title={jobDetailsApply?.title || undefined}
                        >
                            {jobDetailsApply?.title}
                        </Title>
                        <div className={styles.metaRow}>
                            {jobDetailsApply?.workplace ? (
                                <span
                                    className={styles.metaChip}
                                    title={jobDetailsApply.workplace}
                                >
                                    <Icon
                                        className={styles.metaChipIcon}
                                        icon="mdi:office-building-outline"
                                        width={14}
                                    />
                                    <Text className={styles.metaChipText}>
                                        {jobDetailsApply.workplace}
                                    </Text>
                                </span>
                            ) : null}
                            {jobDetailsApply?.location ? (
                                <span
                                    className={styles.metaChip}
                                    title={jobDetailsApply.location}
                                >
                                    <Icon
                                        className={styles.metaChipIcon}
                                        icon="mdi:map-marker-outline"
                                        width={14}
                                    />
                                    <Text className={styles.metaChipText}>
                                        {jobDetailsApply.location}
                                    </Text>
                                </span>
                            ) : null}
                        </div>
                    </>
                )}
            </div>

            <div className={styles.tabsWrap}>
                <Tabs
                    activeKey={activeKey}
                    onChange={(key) => setActiveKey(key)}
                    centered
                    className={`${styles.tabs} job-application-tabs`}
                    items={[
                        {
                            key: 'overview',
                            label: 'Overview',
                            children: jobLoading ? (
                                <div className={styles.contentCard}>
                                    <Skeleton active paragraph={{ rows: 5 }} />
                                </div>
                            ) : (
                                <div className={styles.contentCard}>
                                    <div className={styles.sectionBlock}>
                                        <Title
                                            level={4}
                                            className={styles.sectionTitle}
                                        >
                                            Description
                                        </Title>
                                        <div
                                            className={styles.richText}
                                            dangerouslySetInnerHTML={{
                                                __html: jobDetailsApply?.description,
                                            }}
                                        />
                                    </div>
                                    {jobDetailsApply?.requirements && (
                                        <div className={styles.sectionBlock}>
                                            <Title
                                                level={4}
                                                className={styles.sectionTitle}
                                            >
                                                Requirements
                                            </Title>
                                            <div
                                                className={styles.richText}
                                                dangerouslySetInnerHTML={{
                                                    __html: jobDetailsApply?.requirements,
                                                }}
                                            />
                                        </div>
                                    )}
                                    {jobDetailsApply?.benefits && (
                                        <div className={styles.sectionBlock}>
                                            <Title
                                                level={4}
                                                className={styles.sectionTitle}
                                            >
                                                Benefits
                                            </Title>
                                            <div
                                                className={styles.richText}
                                                dangerouslySetInnerHTML={{
                                                    __html: jobDetailsApply?.benefits,
                                                }}
                                            />
                                        </div>
                                    )}
                                    <div className={styles.applyCtaWrap}>
                                        <button
                                            type="button"
                                            className={styles.applyCta}
                                            onClick={() =>
                                                setActiveKey('application')
                                            }
                                        >
                                            Apply for this job
                                        </button>
                                    </div>
                                </div>
                            ),
                        },
                        {
                            key: 'application',
                            label: 'Application',
                            children: (
                                <div className={styles.formShell}>
                                    <ApplicationForm />
                                </div>
                            ),
                        },
                    ]}
                />
            </div>
        </Layout>
    )
}

export default ApplyForJobPublicPage
